/**
 * features/comms/CommsPage.tsx
 * ------------------------------------------------------------------
 * Communications: branded email, and text messages (SMS) for schools.
 * Two tabs, not two nav entries: the question a person arrives with is "get
 * word to somebody", and the channel is the second decision.
 *
 * There was a WhatsApp tab until Meta permanently disabled Acepsle's WhatsApp
 * Business account (2026-09-12, appeal refused 2026-09-14). That code is in
 * retired/whatsapp/. Do not bring WhatsApp back without the owner's say.
 * ---------------------------------------------------------------- */
import { useState } from 'react';
import { Mail, MessageSquareText } from 'lucide-react';
import { CommsHub } from './CommsHub';
import { SmsHub } from './SmsHub';

const TABS = [
  { key: 'email' as const, label: 'Email', icon: Mail },
  { key: 'sms' as const, label: 'SMS', icon: MessageSquareText },
];

export function CommsPage() {
  const [tab, setTab] = useState<'email' | 'sms'>('email');
  return (
    <div className="space-y-6">
      <div className="flex gap-1 rounded-xl bg-black/5 p-1 dark:bg-white/5">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-1 items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition ${
                active
                  ? 'bg-white text-primary shadow-sm dark:bg-white/10 dark:text-gray-100'
                  : 'text-gray-500 hover:text-primary dark:text-gray-400 dark:hover:text-gray-200'
              }`}
            >
              <Icon size={16} />
              {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'email' ? <CommsHub /> : <SmsHub />}
    </div>
  );
}
